itsoftApp.createModule("tooltips", function () {
    var module = this;
    var openTooltipButtons = document.querySelectorAll(".js-open-tooltip");

    var initTooltip = function (openButton) {
        var tooltipSelector = openButton.getAttribute("data-tooltip");
        var tooltipElement = document.querySelector(tooltipSelector);
        var closeButtons = tooltipElement.querySelectorAll(".js-close-tooltip");
        var otherElements = document.querySelectorAll(".js-opened-tooltip-toggle");

        var closeTooltip = function (evt) {
            evt.preventDefault();
            tooltipElement.classList.remove("is-opened");
            Array.prototype.forEach.call(closeButtons, function (closeButton) {
                closeButton.removeEventListener("click", closeTooltip);
            });

            if (tooltipElement.hasAttribute("data-closed-others") && otherElements) {
                Array.prototype.forEach.call(otherElements, function (el) {
                    el.classList.remove("js-tooltip-toggled");
                });
            }
        }

        var openTooltip = function (evt) {
            evt.preventDefault();

            if (tooltipElement.hasAttribute("data-closed-others") && otherElements) {
                Array.prototype.forEach.call(otherElements, function (el) {
                    el.classList.add("js-tooltip-toggled");
                });
            }

            Array.prototype.forEach.call(closeButtons, function (el) {

            })
            tooltipElement.classList.add("is-opened");

            Array.prototype.forEach.call(closeButtons, function (closeButton) {
                closeButton.addEventListener("click", closeTooltip);
            })
        }

        openButton.addEventListener("click", openTooltip);
    }

    Array.prototype.forEach.call(openTooltipButtons, function (openButton) {
        initTooltip(openButton);
    });

    module.callback = initTooltip;
});